import { modalRenderer } from '~/modal/modalRendererRegistry';
import { AddDataColumnContainer } from './addDataColumn.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    AddDataColumn: undefined;
  }
}
modalRenderer.register('AddDataColumn', AddDataColumnContainer);
